import { onEmulator } from "./constants";
var selfIdentifier = process.env.REACT_APP_SITE_INDENTITY;
function createHandoutFunctionUrl(functionId, region) {
    var _region = region ? region : "asia-east2";
    if (onEmulator) {
        return "http://localhost:5101/project-handout/" + _region + "/" + functionId;
    }
    return "https://" + _region + "-project-handout.cloudfunctions.net/" + functionId;
}
export function fetchFromHandout(func, body, method, region) {
    return fetch(createHandoutFunctionUrl(func, region), {
        method: method ? method : 'POST',
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': selfIdentifier
        }
    });
}
export function postToHandout(func, body, region) {
    return fetch(createHandoutFunctionUrl(func, region), {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': selfIdentifier
        }
    });
}
export function queryToHandout(func, region) {
    var additionalInfo = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': selfIdentifier
        }
    };
    return fetch(createHandoutFunctionUrl(func, region), additionalInfo);
}
//# sourceMappingURL=fetchUtils.js.map